import { TriangleAlert, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CreateWarningToastProps } from "./types";

export default function CreateWarningToast({
  warnings,
  partialFailure,
  onClose,
}: CreateWarningToastProps) {
  if (!partialFailure || !warnings || warnings.length === 0) return null;

  // Build warning message
  // If partial failure occurred, we have 1 variation and warnings about the failed one(s)
  const failedVariationCount = warnings.length;
  const warningMessage =
    failedVariationCount === 1
      ? `Only 1 variation was generated (expected 2). Variation ${warnings[0].variation} failed: ${warnings[0].reason}${warnings[0].error ? ` (${warnings[0].error})` : ""}. The available variation has been automatically selected.`
      : `Only 1 variation was generated (expected 2). ${failedVariationCount} variation(s) failed. The available variation has been automatically selected.`;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md z-50 animate-slide-up">
      <div className="bg-[var(--warning-muted)] border border-border rounded-2xl px-4 py-4 shadow-2xl flex items-start gap-3 backdrop-blur-sm">
        {/* Warning Icon */}
        <div className="flex-shrink-0 mt-0.5">
          <TriangleAlert className="w-6 h-6 text-warning" aria-hidden />
        </div>

        {/* Message */}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-warning leading-relaxed break-words">
            {warningMessage}
          </p>
        </div>

        {/* Close Button */}
        <Button
          onClick={onClose}
          variant="ghost"
          size="sm"
          className="flex-shrink-0 -mr-1 -mt-1 hover:opacity-70 transition-opacity p-1.5 rounded-lg"
          aria-label="Close warning message"
        >
          <X className="w-5 h-5" aria-hidden />
        </Button>
      </div>
    </div>
  );
}
